module.exports = __webpack_public_path__ + "2244c8fccfeaf96a56d146c24a751c84.png";